// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"187":"6d241761","223":"5339a9f0","333":"e0e9a9fd","385":"e0e9a9fd","748":"3c932ae0","893":"5339a9f0","921":"e0e9a9fd"}[chunkId] + ".chunk.css";
};